import Vue, { computed, ref } from 'vue'

export type Theme = 'light' | 'dark'

export function getTheme() {
    return window.localStorage.getItem('theme') as Maybe<Theme>
}

const prefersDark = window.matchMedia('(prefers-color-scheme: dark)').matches

const state = Vue.observable<{ theme: Theme }>({
    theme: prefersDark ? 'dark' : 'light',
})

export function useTheme() {
    const isInit = ref(false)

    function init() {
        const prefersDark = window.matchMedia(
            '(prefers-color-scheme: dark)'
        ).matches
        setTheme(prefersDark ? 'dark' : 'light')

        window
            .matchMedia('(prefers-color-scheme: dark)')
            .addEventListener('change', e => {
                setTheme(e.matches ? 'dark' : 'light')
            })

        isInit.value = true
    }

    function setTheme(t: Theme) {
        document.documentElement.setAttribute('data-theme', t)
        window.localStorage.setItem('theme', t)
        state.theme = t
    }

    if (!isInit.value) {
        init()
    }

    const theme = computed(() => state.theme)

    return {
        theme,
        setTheme,
    }
}
